var isObject = require('./../support/isObject');

module.exports = isJSONEnvelope;

function isJSONEnvelope(envelope) {
    return isObject(envelope) && ('json' in envelope);
}



// WEBPACK FOOTER //
// ./lib/support/isJSONEnvelope.js